export class SipCredential {
  constructor(
    readonly username: string,
    readonly password: string,
    readonly url: string,
  ) {}
}
